import { Grid } from "@material-ui/core";
import TmpButtonGroupCustom from "../TmpButtonGroupCustom/TmpButtonGroupCustom";
import { ReactComponent as IconInfo } from "../../../assets/icons/info.svg";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import TmpTypographyCustom from "../TmpTypographyCustom/TmpTypographyCustom";

interface TmpStepButtonsCustomProps {
    onBackClick?: () => void;
    onNextClick?: () => void;
    onFinishClick?: () => void;
    currentStep: number;
    isLoading: boolean;
    totalSteps: number;
}

export default function TmpStepButtonsCustom(props: TmpStepButtonsCustomProps) {

    return (
        <Grid container>
            <Grid item xs={5}>
                <div style={{ display: "flex" }}>
                    <TmpIconCustom icon={<IconInfo />} size="sm" />
                    <div style={{ padding: "5px" }}>
                        <TmpTypographyCustom component="caption" size="small" variant="h6" id="mensagem-1">
                            As informações inseridas são salvas automaticamente ao avançar.
                        </TmpTypographyCustom>
                    </div>
                </div>
            </Grid>
            <Grid item xs={7}>
                <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>

                    {props.currentStep !== props.totalSteps ? (

                        <TmpButtonGroupCustom
                            labelPrimary="Avançar"
                            size="lg"
                            loadingButtonPrimary={props.isLoading}
                            labelSecondary="Voltar"
                            handleClickPrimary={props.onNextClick}
                            handleClickSecondary={props.onBackClick}
                        />

                    ) : (

                        <TmpButtonGroupCustom
                            labelPrimary="Finalizar"
                            size="lg"
                            loadingButtonPrimary={props.isLoading}
                            labelSecondary="Voltar"
                            handleClickPrimary={props.onFinishClick}
                            handleClickSecondary={props.onBackClick}
                        />
                    )}
                </div>
            </Grid>
        </Grid>
    );
}
